const SupplementTypes = ['supplement', 'supplement_percent'];

export default SupplementTypes;
